export const DEMOGRAPHICS_FIELD_NAMES = {
  gender: 'gender',
  ethnicity: 'ethnicity',
  race: 'race',
  householdAccessibilityNeeds: 'householdAccessibilityNeeds',
  reasonableAccommodation: 'reasonableAccommodation',
  accommodationDescription: 'accommodationDescription',
  displacementStatus: 'displacementStatus',
};
